/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import { section1Questions } from "./section1Questions";
import { section2Questions } from "./section2Questions";
import { section3Questions } from "./section3Questions";
import { section4Questions } from "./section4Questions";
import { section5Questions } from "./section5Questions";
import { section6Questions } from "./section6Questions";
import { section7Questions } from "./section7Questions";
import { section8Questions } from "./section8Questions";
import { section9Questions } from "./section9Questions";
import { section10Questions } from "./section10Questions";
import { section11Questions } from "./section11Questions";
import { section12Questions } from "./section12Questions";
import { section13Questions } from "./section13Questions";
import { section14Questions } from "./section14Questions";
import { section15Questions } from "./section15Questions";
import { laaWorkerSectionQuestions } from "./laaWorkerSectionQuestions";

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 * We should create a new version or similar for use with the FastTrackPitPupMedicalForm component
 */
export const questions = [
    ...section1Questions,
    ...section2Questions,
    ...section3Questions,
    ...section4Questions,
    ...section5Questions,
    ...section6Questions,
    ...section7Questions,
    ...section8Questions,
    ...section9Questions,
    ...section10Questions,
    ...section11Questions,
    ...section12Questions,
    ...section13Questions,
    ...section14Questions,
    ...section15Questions,
    ...laaWorkerSectionQuestions
];
